import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const NavigationIcon = createSvgIcon(
  <>
    <path
      d="M4 8H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4 12H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4 16H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </>,
  "NavigationIcon"
);
